import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {MemberSt} from 'hiya-common/src/reducers/commonTypes'
import {statusEnum, task_type_enum} from './constant'
// 待确认（黄色）已确认（绿色）已拒绝（红色）已失效（灰色）
export enum InviteStatus {
  Confirm = 0,
  审核中 = 1,
  Confirmed = 2,
  审核未通过 = 3,
  Reject = 4,
  Fail = 5,
}
// 0；用户未处理

// 1；审核中（用户有一个申请）

// 2；审核通过 （用户已成为主播）

// 3；审核未通过

// 4；用户已拒绝

// 5；邀请已过期

// [邀请用户] http://wiki.xunlei.cn/pages/viewpage.action?pageId=113920575
export const invite_user = createAsyncThunk(
  '/live/master_union/invite_user',
  async (
    arg: {
      m_union_id: number
      target_mid: number
    },
    store: any
  ) => {
    const resp = await http.post(
      '/live/master_union/invite_user',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

// [团长主页] http://wiki.xunlei.cn/pages/viewpage.action?pageId=113920554
export const union_homepage = createAsyncThunk(
  '/live/master_union/union_homepage',
  async (arg, store: any) => {
    const resp = await http.post('/live/master_union/union_homepage', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
// [达人主页] http://wiki.xunlei.cn/pages/viewpage.action?pageId=113920535
export const master_homepage = createAsyncThunk(
  '/live/master_union/master_homepage',
  async (arg, store: any) => {
    const resp = await http.post('/live/master_union/master_homepage', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
// [任务中心主页] http://wiki.xunlei.cn/pages/viewpage.action?pageId=117016399
export const task_homepage = createAsyncThunk(
  '/live/master_union/task_homepage',
  async (arg, store: any) => {
    const resp = await http.post('/live/master_union/task_homepage ', {
      ...store.getState().env.deviceinfo,
      ...store.getState().env.otherInfo,
    })
    return resp.data.data
  }
)
// [完成任务] http://wiki.xunlei.cn/pages/viewpage.action?pageId=117016432
export const finish_task = createAsyncThunk(
  '/live/master_union/finish_task',
  async (arg: {tid: number}, store: any) => {
    const resp = await http.post(
      '/live/master_union/finish_task',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export interface INotify {
  id: number
  title: string
  content: string
  ct: string
  red_dot?: RedDotStatus
}

export enum RedDotStatus {
  unread = 1,
  read = 2,
}

// 陪聊主播通知中心读取某条通知 http://wiki.xunlei.cn/pages/viewpage.action?pageId=105291628
export const anchor_read_messagen = createAsyncThunk(
  '/live/facetime/anchor_read_message',
  async (p: any = {}, store: any) => {
    const resp = await http.post('/live/facetime/anchor_read_message', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)
// 支付入口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92448321
export const getPayEnter = createAsyncThunk(
  'facetime/getPayEnter',
  async (p: any, store: any) => {
    const resp = await http.post('/live/facetime/pay_enter', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
export enum review_status_enum {
  是主播 = 1,
  申请中 = 2,
  申请失败 = 3,
}
// 题目类型
export enum qTypeEnum {
  单选 = 1,
  多选 = 2,
}
// 团长历史收益
export interface IncomeInfo {
  st_day: string
  ed_day: string //	日期
  score: number //	积分数
}
interface TalentIncomeItem {
  name: string //	积分名字
  socre: number //	积分数量
}
// 达人收益
export interface TalentIncome {
  day: string //	日期
  total: number //	总收益
  salary: number // 总收益对应的薪资
  list: TalentIncomeItem[] //	各个渠道的收益
}
// 达人信息
export interface MasterItem {
  mid: number
  name: string //	用户昵称
  score: number //	积分数量
  avatar: string
  migrant: boolean // 是否已迁移到higo
}
// 达人团
interface MasterUnion {
  m_union_id: number //	团id
  name: string // 工会名字
  code?: string //	邀请码	可选
  mid: number //	团长mid
  ct: number //	创建时间戳
}
export interface NoviceTaskInfo {
  tid: number //	任务id
  title: string //	积分名字
  sub_title: string //	积分数量
  img: string //	图片
  count: number //	积分数
  status: statusEnum
  jump: string //	跳转地址
}
export interface DailyTaskInfo {
  task?: NoviceTaskInfo
  cur_finish_count: number //	当前完成任务次数
  max_finish_count: number //	最大完成次数
}
export interface TaskPoint {
  points: number //	赚取的积分数
  threshold: number //	门槛，需要达到多少分数才能领取
  status: statusEnum
  threshold_str: string //	门槛+单位
}
export interface AdvancedTaskInfo {
  task: NoviceTaskInfo
  cur_finish_count: number //	当前完成任务次数
  max_finish_count: number //	最大完成次数
  cur_count: number //	当前的积分数，需要和point_list中的threshold比较，得到当前在什么进度
  point_list: TaskPoint[] //	进度条
}
export interface OnlineTaskInfo {
  tid: number //	任务Id
  points: number //	赚取的积分数
  cur_online_hours: number //	当前在线小时数
  max_online_hours: number //	最大在线小时数
  cur_online_day: number //	当前在线天数
  max_online_day: number //	最大在线天数
  min_online_hours: number // 在线天最低小时数
  status: statusEnum
}
export interface TaskInfo {
  name: string //	任务名称
  type: task_type_enum
  list: any[]
  // | NoviceTaskInfo[]
  // | DailyTaskInfo[]
  // | AdvancedTaskInfo[]
  // | OnlineTaskInfo[]
}
interface WorkData {
  duration: number //	工作秒数
  day: number //	有效天数
  call_time: number //	有效电话次数
  e_chat: number //	5回合达成数量
  e_direct: number //	有效定向电话数量：超过30s的定向电话，不算匹配的；
  e_match: number //	有效匹配数量 （超过30s），这个字段原先有的 叫 valid calls
}
export interface BannerItem {
  id: number
  cover: string //	图片
  link: string //		跳转链接
}
export interface InitialStateType {
  union_homepage?: {
    master_union: MasterUnion
    member_union?: MemberSt // 团长用户信息
    master_list: MasterItem[]
    weekly_score: number // 本周收益的积分
    money: number // 可提现的收益
    list: any[]
    unread_cnt?: number
    banner_list?: BannerItem[]
  }
  master_homepage?: {
    today_income: TalentIncome
    total_score: number // 当前的积分数
    can_withdraw_count: number // 可提现的美金
    threshold: number // 提现美金门槛
    master_union: MasterUnion // 达人团信息
    member_union?: MemberSt // 团长用户信息
    video: string //	教学视频
    cover: string //	教学视频封面
    dollar_rate: number // 1美金对应多少积分
    today_data: WorkData
    this_week_data: WorkData
    last_week_data: WorkData
    unread_cnt?: number
    banner_list?: BannerItem[]
    show_chat_helper: boolean
    show_facetime_helper: boolean
    helper_scheme: string
  }
  task_homepage?: {
    points: number
    task_list: TaskInfo[]
    task_config: {
      new_user_task: {
        round: string
        points: string
      }
    }
  }
  pay_enter?: any
}

const initialState: InitialStateType = {}

export const TalentsCenterSlice = createSlice({
  name: 'TalentsCenter',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(union_homepage.fulfilled, (state, action) => {
      Object.assign(state, {union_homepage: action.payload})
    })
    builder.addCase(master_homepage.fulfilled, (state, action) => {
      Object.assign(state, {master_homepage: action.payload})
    })
    builder.addCase(task_homepage.fulfilled, (state, action) => {
      Object.assign(state, {task_homepage: action.payload})
    })
    builder.addCase(getPayEnter.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, {pay_enter: data})
    })
  },
})
export default TalentsCenterSlice.reducer
export const VChatCenterActions = TalentsCenterSlice.actions
